<template>
  <div class="container vipactive_bg">
    <div class="head">
      <div class="head__fixed">
        <div class="head__fixed__box">
          <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
          <div class="header__fixed__center">
            <h1>企业专区</h1>
          </div>
          <div class="header__fixed__right"></div>
        </div>
      </div>
    </div>

    <div class="login" v-if="vag_status==1">
      <h1 class="hello">尊敬的企业客户，</h1>
      <p class="welcome">您正在通过企业专属通道激活VIP权益</p>
      <div class="login__form">
        <div class="login__item">
          <!-- <div class="login_phone"></div> -->
          <!-- <div class="areasel">+86</div> -->
          <div class="areasel">+86</div>
          <div class="input"><input type="tel" maxlength="11" placeholder="输入手机号" v-model="param.mobile"><span class="clear" v-show="clearFlag"></span></div>
        </div>
        <div class="form__note"></div>
        <div class="login__item">
          <!-- <div class="login_phone2"></div> -->
          <div class="input"><input type="tel" maxlength="6" placeholder="请输入验证码" v-model.trim="param.sms_code"></div>
          <div class="getcode" @click.stop.prevent="getSmsCaptcha">{{codeTxt}}</div>
        </div>
        <div class="form__note" style="visibility:visible">{{loginNote}}</div>
      </div>
      <!-- <div class="login__btn">登录</div> -->
    </div>

    <div class="login" v-else-if="vag_status==2">
      <h1 class="hello">尊贵的企业客户，</h1>
      <p class="welcome">您正在通过企业专属通道激活VIP权益</p>
      <!-- <div class="form__item form__input">
        <div class="cont">
          <div class="vag_input">当前手机号：{{hidePhoneNum}}</div>
        </div>
      </div> -->
      <div class="login__form">
        <div class="login__item" v-if="inpuable">
          <div class="login_phone3" v-if="inpuable"></div>
          <div class="login_phonett" v-else></div>
          <div class="input" v-if="inpuable">
            <input type="text" v-model="param.name" placeholder="请输入您的真实姓名">
          </div>
          <div class="input" v-else>
            <input type="text" v-model="param.name" disabled="disabled">
          </div>
        </div>
        <div class="login__item1" v-else style="border: none;">
          <div class="login_phone3" v-if="inpuable"></div>
          <div class="login_phonett" v-else></div>
        </div>

      </div>
      <div class="form__note" v-if="inpuable" style="visibility:visible">首次激活请务必正确输入您的真实姓名，以便正常使用权益</div>
      <div class="form__note" v-else style="visibility:visible"></div>
      <!-- <div class="form__btn">激活VIP会员</div> -->
    </div>

    <div class="vipactivation" v-else-if="vag_status==3">
      <h1 class="hello">尊贵的企业客户，</h1>
      <p class="welcome">激活VIP会员开始体验五星级酒店健身瑜伽服务</p>
      <div class="form__item form__input">
        <!-- <div class="label icon__key"></div> -->
        <div class="cont">
          <div class="vag_input">当前手机号：{{hidePhoneNum}}</div>
        </div>
      </div>
      <div class="form__item form__input">
        <div class="cont">
          <div class="vag_input">姓名：{{param.name}}</div>
        </div>
      </div>
    </div>
    <!-- class="vagtotal_btn" -->
    <div  v-if="vag_status != 0">
      <button class="form__btn_group_vip" v-preventReClick v-if="vag_status==2" @click.stop.prevent="vag_activation_early()">激活企业权益</button>
      <button class="form__btn_group_vip" v-preventReClick v-else-if="vag_status==3" @click.stop.prevent="vag_activation_act()">立即激活</button>
      <button class="form__btn_group_vip" v-preventReClick v-else @click="vag_login()">登录</button>
      <div class="form__btn_group_vip_tips" @click.stop.prevent="vag_toVipActivation()">激活码兑换></div>
    </div>

  </div>
</template>

<script>
  import {
    isPhone
  } from "../../lib/utils.js"
  export default {
    data() {
      return {
        vag_status:0,
        param: {
          code: "",
          name: "",
          mobile: "",
          sms_code: "",
        },
        codeTxt: "获取验证码",
        loginNote: "",
        clearFlag: false,
        inputAbled: true,
        userinfo: {},
        hidePhoneNum: '',
        inpuable:true,
        realnameearly:0//0未实名  1实名
      }
    },
    created() {
      this.$loading.open()
    },
    watch: {
    },
    mounted() {
      this.userStatus();
    },
    methods: {

      // 用户状态
      userStatus() {
        var $this = this

        if (localStorage.getItem("token")==''||localStorage.getItem("token")==null||localStorage.getItem("token")==undefined) {
          // 无token,先登录
          $this.vag_status = 1
          $this.$loading.close()
          this.getUserinfo()
        } else {
          // 获取用户信息，查看是否实名
          this.getUserinfo()
        }
      },
      // 获取验证码
      getSmsCaptcha() {
        let that = this;
        if (!isPhone(this.param.mobile)) {
          this.loginNote = "请输入正确手机号"
          return;
        } else {
          this.loginNote = "";
        }
        if (this.codeTxt == "获取验证码") {
          let param = {
            openid: localStorage.getItem("openid"),
            mobile: this.param.mobile
          }
          // getSmsCaptcha
          var qs = require('qs');
          let url = this.api.userApi.getSmsCaptcha
          this.axios.post(url,qs.stringify(param),)
          .then((result) => {
            // console.log(result)
            if (result.code == 0) {
              that.codeTxt = "60s";
              let s = 60
              setInterval(function() {
                s -= 1;
                if (s > 0) {
                  that.codeTxt = s + "s";
                } else {
                  that.codeTxt = "获取验证码";
                }
              }, 1000)
            }else{
              $this.$toast(result.msg);
            }
          }).catch((error) => {
            console.warn(error)
            // $this.$toast('error');
          })

        }
      },
      // 登录
      vag_login() {
        var $this = this
        // // console.log('login')
        if (!isPhone(this.param.mobile)) {
          this.loginNote = "请输入正确手机号"
          return;
        } else {
          this.loginNote = "";
        }

        var source=localStorage.getItem("source")
        if(source==null||source==undefined||source==''){
          source = '';
        }

        let param = {
          openid: localStorage.getItem("openid"),
          mobile: this.param.mobile,
          sms_code: this.param.sms_code,
          source:source
        }
        var qs = require('qs');
        let url = this.api.userApi.getLogin
        this.axios.post(url,qs.stringify(param),)
        .then((result) => {
          // console.log(result)
          if (result.data) {
            localStorage.setItem("token", result.data.token);
            $this.jumpRealName()
            $this.getUserinfo()
            sessionStorage.setItem('realName','yes')
          } else {
            $this.loginNote = result.msg
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$toast('error');
        })
      },
      // 手机号隐藏
      userPhoneHide(cellValue) {
        if (Number(cellValue) && String(cellValue).length === 11) {
          var mobile = String(cellValue)
          var reg = /^(\d{3})\d{4}(\d{4})$/
          return mobile.replace(reg, '$1****$2')
        } else {
          return cellValue
        }
      },
      // 获取用户信息
      getUserinfo() {
        var $this = this
        let param = {
          token: localStorage.getItem("token")
        }
        var qs = require('qs');
        let url = this.api.userApi.getInfo
        this.axios.post(url,qs.stringify(param),)
        .then((result) => {
          // console.log(result)
          $this.$loading.close()
          if (result.data) {
            $this.jumpRealName()
            $this.vag_status = 2
            $this.userinfo = result.data.user
            localStorage.setItem("userinfo", JSON.stringify(result.data.user));
            if (result.data.user.name == ''||result.data.user.name == null||result.data.user.name == undefined) {
              $this.inpuable=true
            } else {
              $this.inpuable=false
              $this.param.name = result.data.user.name
            }
          } else {
            $this.$toast(result.msg)
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$toast('error');
          $this.$loading.close()
        })
      },
      activeCard() {},
      // 保留，看App.vue
      getData() {},
      //
      jumpRealName(){

        var $this = this
        $this.$loading.open()
        let param = {
          token: localStorage.getItem("token")
        }
        // getInfo
        var qs = require('qs');
        let url = this.api.userApi.getInfo
        this.axios.post(url,qs.stringify(param),)
        .then((result) => {
          $this.$loading.close()
          if (result.data) {
            if (result.data.user.name == ''||result.data.user.name == null||result.data.user.name == undefined) {
              $this.realnameearly=0
            } else {
              $this.realnameearly=1
            }
          } else {
            $this.$toast(result.msg)
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$toast('error');
          $this.$loading.close()
        })
      },
      //
      vag_activation_early(){
        var $this = this
        if($this.realnameearly==0){
          $this.vag_activation()
        }else{
          $this.vag_activation_act()
        }
      },
      // 实名认证
      vag_activation() {

        var $this = this
        $this.$loading.open()
        let param = {
          token: localStorage.getItem("token"),
          name: $this.param.name
        }
        // getRealNameSystem
        var qs = require('qs');
        let url = this.api.userApi.getRealNameSystem
        this.axios.post(url,qs.stringify(param),)
        .then((result) => {
          if (result.code == 0) {
            $this.vag_activation_act()
            // $this.vag_status=3
          } else {
            $this.$toast(result.msg);
            $this.$loading.close()
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$toast('error');
          $this.$loading.close()
        })

      },
      // 激活
      vag_activation_act() {
        // activationByUser
        var $this = this
        let param = {
          token: localStorage.getItem("token")
        }
        //
        var qs = require('qs');
        let url = this.api.userApi.getActivationByUser
        this.axios.post(url,qs.stringify(param),)
        .then((result) => {

          $this.$loading.close()
          if (result.code == 0) {
            // 我的会员卡列表发生变化，vuex 更新我的会员卡
            var temp=[]
            $this.$store.commit('setMyCards',temp)
            // $this.vag_status=3
            this.$dialog.alert({
              title: '温馨提示',
              message: '激活成功！',
              confirmButtonText: '查看详情',
              confirmButtonColor: '#000'
            }).then(() => {
              // on close
              $this.$router.push({
                name: "myCard"
              });
            });
          } else {
            $this.$toast(result.msg);
          }
        }).catch((error) => {
          console.warn(error)
          // $this.$toast('error');
          $this.$loading.close()
        })
      },
      // 直接tips
      vag_activationAlert() {
        var $this = this
        this.$dialog.alert({
          title: '温馨提示',
          message: '恭喜！企业VIP激活成功',
          confirmButtonText: '查看详情',
          confirmButtonColor: '#000'
        }).then(() => {
          // on close
          $this.$router.push({
            name: "vip"
          });
        });
      },
      // 去个人激活专区
      vag_toVipActivation() {
        this.$router.push({
          name: "activate_single"
        });
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .hello{
  	font-size:54*@vm_base;
  	font-weight:600;
  	color:#444054;
  	line-height:75*@vm_base;
  }
  .welcome{
  	margin-top:20*@vm_base;
  	margin-bottom:60*@vm_base;
  	font-size:30*@vm_base;
  	font-weight:400;
  	color:rgba(39,39,39,1);
  	line-height:42*@vm_base;
  }
  .login{
  	padding:60*@vm_base 40*@vm_base;
   //  background:url(../images/login/bg_login.png) no-repeat;
  	// background-size:250*@vm_base 232*@vm_base;
   //  background-position: top right;

  	.input{
  		position:relative;
  		flex:5;
  		input{
  			width:100%;
  			padding:10*@vm_base 40*@vm_base 10*@vm_base 0;
  			font-size:30*@vm_base;
  			font-weight:400;
  			color:#333;
  			line-height:42*@vm_base;
  		}
  		.clear{
  			position:absolute;
  			right:0;
  			top:16*@vm_base;
  			width:30*@vm_base;
  			height:30*@vm_base;
  			background:url(../../assets/images/base/icon_clear.png) no-repeat;
  			background-size:30*@vm_base auto;
  		}
  	}
  	.login__item{
  		display:flex;
  		padding-bottom:10*@vm_base;
  		border-bottom:1px solid #EBEBEB;
      height: 90*@vm_base;
      line-height: 90*@vm_base;
      background: #FFFFFF;
      padding: 0 32*@vm_base;
      border-radius:12*@vm_base;
      border:1*@vm_base solid rgba(235,235,235,1);
  	}
    .login__item1{
      display:flex;
      padding-bottom:10*@vm_base;
      border-bottom:1px solid #FFFFFF;
    }
  	.login__btn{
  		width:100%;
  		height:96*@vm_base;
  		background:linear-gradient(132deg,rgba(116,114,114,1) 0%,rgba(59,53,53,1) 100%);
  		border-radius:3px;
  		font-size:32*@vm_base;
  		font-weight:600;
  		color:rgba(255,255,255,1);
  		line-height:96*@vm_base;
  		text-align:center;
  	}
  	.areasel{
  		flex:1;
  		height: 90*@vm_base;
      line-height: 90*@vm_base;
  	}
  	.getcode{
  		flex:2;
  		// padding-top:10*@vm_base;
  		text-align:right;
  		font-size:30*@vm_base;
  		font-weight:400;
  		color:rgba(51,51,51,1);
  		height: 90*@vm_base;
  		line-height: 90*@vm_base;
  	}
  }
  .form__note{
  	width:100%;
  	height:40*@vm_base;
  	margin-top:10*@vm_base;
  	font-size:24*@vm_base;
  	font-weight:400;
  	color:rgba(255,85,46,1);
  	line-height:40*@vm_base;
  	visibility: hidden;
  }

  .vipactivation{
    // background:url(../images/login/bg_login.png) 0 70*@vm_base no-repeat;
    background-size:536*@vm_base auto;
  	padding:60*@vm_base 40*@vm_base;
  	.form__item{
  		border-bottom:1px solid #EBEBEB;
  		.label{
  			flex:initial;
  		}
  		.cont{
  			padding-left:30*@vm_base;
  			text-align:left;

  		}
  		input{
  			text-align:left;
  		}
  	}
  }
  .form__btn_group_vip{
  	width:calc(100% - 80*@vm_base);
  	height:90*@vm_base;
  	line-height:90*@vm_base;
  	// margin-top:80*@vm_base;
  	background:linear-gradient(147deg,rgba(68,64,84,1) 0%,rgba(68,64,84,1) 100%);
  	border-radius:12*@vm_base;
  	text-align:center;
  	font-size:34*@vm_base;
  	font-family:PingFangSC-Regular,PingFang SC;
  	font-weight:400;
  	color:rgba(255,255,255,1);
    margin:0 40*@vm_base 33*@vm_base 40*@vm_base;
    outline: none;
  }
  .form__btn_group_vip_tips{
    width:calc(100% - 80*@vm_base);
    // height:90*@vm_base;
    // line-height:90*@vm_base;
    // margin-top:80*@vm_base;
    // background:linear-gradient(132deg,rgba(116,114,114,1) 0%,rgba(59,53,53,1) 100%);
    // border-radius:3px;
    text-align:right;
    font-size:28*@vm_base;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:#444054;
    margin:0 40*@vm_base 60*@vm_base 40*@vm_base;
  }
  .vipactive_bg{
    background-image:url(../../assets/images/base/activevip_bg.png);
    background-repeat: no-repeat;
    background-size: 250*@vm_base 232*@vm_base;
    background-position: 100% 15%;
  }
</style>



// WEBPACK FOOTER //
// src/components/activate/activate_group.vue